import { CrashHistoryItem } from '@/components/features/casino/crash/types/crash';
import { Close as CloseIcon } from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { DialogTitle, DialogTitleProps, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import CrashGameDetail from '../DetailModal/CrashGameDetail';
import CrashHistoryTable from '../HistoryTable';
import { CDialog, StyledDialogContent } from './styles';

interface CrashHistoryModalProps {
  isOpen: boolean;
  handleClose?: () => void;
}

const CrashHistoryModal: React.FC<CrashHistoryModalProps> = ({
  isOpen,
  handleClose,
}) => {
  const { t } = useTranslation();
  const showDetail = (data: any) => {
    setRowData(data);
    setDetailIsShow(true);
  };
  const [detailIsShow, setDetailIsShow] = useState(false);
  const [rowData, setRowData] = useState<CrashHistoryItem | null>(null);
  const clickBack = () => {
    setDetailIsShow(false);
  };
  const handleCloseLogic = () => {
    handleClose?.();
    setDetailIsShow(false);
  };
  const CDialogTitle = (props: DialogTitleProps) => {
    const { children, ...other } = props;

    return (
      <DialogTitle
        sx={{
          m: 0,
          p: 3,
          backgroundColor: (theme) => theme.palette.grey[900],
          fontFamily: 'Readex Pro',
          textTransform: 'uppercase',
        }}
        {...other}
      >
        {children}
        {handleClose ? (
          <IconButton
            aria-label="close"
            onClick={handleCloseLogic}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  return (
    <CDialog open={isOpen} onClose={handleCloseLogic}>
      <CDialogTitle>
        {detailIsShow && (
          <IconButton onClick={clickBack}>
            <ArrowBackIcon />
          </IconButton>
        )}
        {t('Crash History')}
      </CDialogTitle>
      <StyledDialogContent>
        {!detailIsShow && <CrashHistoryTable showDetail={showDetail} />}
        {detailIsShow && <CrashGameDetail detail={rowData}></CrashGameDetail>}
      </StyledDialogContent>
    </CDialog>
  );
};

export default CrashHistoryModal;
